// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4557":"ec7a0023","4872":"dce56fb2"}[chunkId] + ".chunk.css";
};